import '../../modules/mode-components';

import * as angular from 'angular';
import * as $ from 'jquery';

function reportDropDirective() {
  return {
    restrict: 'A',
    link: function (scope, element, attrs) {
      const elem = element[0];
      elem.draggable = true;

      elem.addEventListener(
        'dragover',
        function (e) {
          e.dataTransfer.dropEffect = 'move';
          // allows us to drop
          if (e.preventDefault) {
            e.preventDefault();
          }
          this.classList.add('report-drag-over');
          return false;
        },
        false
      );

      elem.addEventListener(
        'dragenter',
        function (e) {
          this.classList.add('report-drag-over');
          return false;
        },
        false
      );

      elem.addEventListener(
        'dragleave',
        function (e) {
          this.classList.remove('report-drag-over');
          return false;
        },
        false
      );

      elem.addEventListener(
        'drop',
        function (e) {
          // prevent browser quirk of redirecting
          if (e.stopPropagation) {
            e.stopPropagation();
          }

          this.classList.remove('report-drag-over');

          // TODO: handle space move
          // e.dataTransfer.getData('Text');

          return false;
        },
        false
      );
    },
  };
}

angular.module('mode.components').directive('reportDrop', reportDropDirective);
